import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete } from "@shared/components/AutocompleteFields";
import { useBusinessTypeOptions } from "@shared/options";

export function LandingForm() {
  const translate = useTranslate();
  const { getBusinessTypeOptions } = useBusinessTypeOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="slug"
          label={translate("v1/landing_admin.fields.slug")}
          instructions={translate("v1/landing_admin.instructions.slug")}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="metadata.nomeLanding"
          label={translate("v1/landing_admin.fields.nomeLanding")}
          instructions={translate("v1/landing_admin.instructions.nomeLanding")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("v1/landing_admin.fields.agreement")}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="type"
          label={translate("v1/landing_admin.fields.type")}
          options={getBusinessTypeOptions()}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="email"
          label={translate("v1/landing_admin.fields.email")}
          type="email"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker
          name="phone_image"
          label={translate("v1/landing_admin.fields.logo")}
          shape="square"
          size={150}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="welcome_text"
          label={translate("v1/landing_admin.fields.welcome_text")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.ColorPickerInput
          name="welcome_text_color"
          label={translate("v1/landing_admin.fields.welcome_text_color")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="metadata.buttonRegisterName"
          label={translate("v1/landing_admin.fields.buttonRegisterName")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="metadata.buttonCpfName"
          label={translate("v1/landing_admin.fields.buttonCpfName")}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="metadata.benefitsName"
          label={"Nome do botão de Benefícios & SVAs"}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="metadata.moduleExternalCode"
          label={"Habilitar Assinatura Por External Code"}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="metadata.buttonSubscriptionExternalCode"
          label={"Texto do botão de Assinatura External Code"}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="metadata.maskSubscriptionExternalCode"
          label={"Mascara do input de Assinatura External Code"}
          options={[
            { label: "E-mail", value: "email" },
            { label: "Telefone", value: "phone" },
          ]}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="metadata.labelSubscriptionExternalCode"
          label={"Label do input de Assinatura External Code"}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="metadata.subscription"
          label={translate("v1/landing_admin.fields.subscription")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="metadata.removePlan"
          label={"Remover modulo de planos"}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="metadata.profileEdit"
          label={translate("v1/landing_admin.fields.profileEdit")}
        />
      </Grid>
    </Grid>
  );
}
